import { render, staticRenderFns } from "./InstructionLink.pug?vue&type=template&id=3c4f3492&lang=pug&"
import script from "./InstructionLink.vue?vue&type=script&lang=js&"
export * from "./InstructionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports